import { render, staticRenderFns } from "./ServicesTaxNote.vue?vue&type=template&id=ff44c41e&scoped=true&"
import script from "./ServicesTaxNote.vue?vue&type=script&lang=js&"
export * from "./ServicesTaxNote.vue?vue&type=script&lang=js&"
import style0 from "./ServicesTaxNote.vue?vue&type=style&index=0&id=ff44c41e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff44c41e",
  null
  
)

export default component.exports